import { render } from "./ListOfParticipantGroups.vue?vue&type=template&id=d638fb6c&ts=true"
import script from "./ListOfParticipantGroups.vue?vue&type=script&lang=ts"
export * from "./ListOfParticipantGroups.vue?vue&type=script&lang=ts"

import "./ListOfParticipantGroups.vue?vue&type=style&index=0&id=d638fb6c&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__